module.exports = __webpack_public_path__ + "img/drt14.42d439b3.png";